import {fromJson, URL_BASE_AUTH} from "../utils/helper.js";


class SiteDocument {


    constructor() {

        this.id = null;
        this.description = null,
        this.file = null

    }


    static fromJson(object) {
        return fromJson((new SiteDocument()), object);
    }

}

export default SiteDocument;
